'use client';

import FeatureInfoCardsSectionT, {
  InfoCardT,
} from '@factories/RowFactory/components/FeatureInfoCardsSection/types';
import {
  CardsWrapper,
  StyledCard,
  StyledFeatureInfoCardsSection,
  StyledSlider,
} from '@factories/RowFactory/components/FeatureInfoCardsSection/styled/StyledFeatureInfoCardsSection';
import { renderParagraphs } from '@lib/utils';
import React from 'react';
import Image from 'next/image';
import { useMediaQuery, useIsClient } from 'usehooks-ts';
import {
  NextArrow,
  PrevArrow,
} from '@factories/RowFactory/components/FeatureInfoCardsSection/CustomArrows';

const InfoCard = ({ card }: { card: InfoCardT }) => {
  return (
    <StyledCard>
      <div className="image-wrapper">
        <Image
          src={card.icon.url as string}
          alt={card.title}
          width={card.icon.width}
          height={card.icon.height}
          objectFit="contain"
        />
      </div>
      <div className="card-title">{card.title}</div>
      <div className="card-description">
        {renderParagraphs({ body: card.description, hasMarkdown: true })}
      </div>
    </StyledCard>
  );
};

export const FeatureInfoCardsSection = ({
  display,
  title,
  description,
  cards,
}: FeatureInfoCardsSectionT) => {
  const isClient = useIsClient();
  const isMobile = useMediaQuery('(max-width: 767px)');

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  if (!display || !isClient) return null;

  return (
    <StyledFeatureInfoCardsSection>
      <div className="container">
        <div className="header">
          <h2>{title}</h2>
          <p>{renderParagraphs({ body: description, hasMarkdown: true })}</p>
        </div>
        {isMobile ? (
          <StyledSlider key="slider" {...sliderSettings}>
            {cards.map((card, index) => (
              <InfoCard key={index} card={card} />
            ))}
          </StyledSlider>
        ) : (
          <CardsWrapper key="grid">
            {cards.map((card, index) => (
              <InfoCard key={index} card={card} />
            ))}
          </CardsWrapper>
        )}
      </div>
    </StyledFeatureInfoCardsSection>
  );
};
